import {  Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Http, } from '@angular/http';
import { ObjetsService } from '../../shared';
import {FcButtonPositionService} from '../../services/fc-button-position.service';

@Component({
  selector: 'app-home-text',
  templateUrl: './app-home-text.component.html',
  providers: [ObjetsService]
})
export class AppHomeTextComponent implements OnInit {
  @Input() type = 'success';
  @Input() id: number;
  @Input() save: boolean;
  @Output() close: EventEmitter<number>  = new EventEmitter<number>();
  @Output() keep: EventEmitter<any>  = new EventEmitter<any>();

  public metaData: any = [];
  public datas: any = [];
  private alive = true;

  constructor(
    private http: Http,
    private _objetsService: ObjetsService,
    private _fcButtonPositionService: FcButtonPositionService
  ) {}

  ngOnInit (): void {
    this.loadHomeText();
  }

  homeLoad(): void {
    this._fcButtonPositionService.setListSessions(true);
  }

  loadHomeText(): void {
    this._objetsService.homeText().takeWhile(() => this.alive).subscribe(
      result => {
        this.datas = result;

      },
      error => { this.metaData = <any>error }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-home-text/app-home-text.component.ts